import { useEffect, useState } from 'react'

export function usePageVisibility() {
    const [isVisible, setIsVisible] = useState(() => {
        return !document.hidden && document.hasFocus()
    })


    useEffect(() => {
        const updateVisibility = () => {
            const newVisibility = !document.hidden && document.hasFocus()
            setIsVisible(newVisibility)
        }

        const events = ['visibilitychange', 'focus', 'blur', 'pageshow', 'pagehide']

        events.forEach((event) => {
            window.addEventListener(event, updateVisibility)
            document.addEventListener(event, updateVisibility)
        })

        const interval = setInterval(updateVisibility, 500)

        updateVisibility()

        return () => {
            events.forEach((event) => {
                window.removeEventListener(event, updateVisibility)
                document.removeEventListener(event, updateVisibility)
            })
            clearInterval(interval)
        }
    }, [])

    return isVisible
}
